import { useTranslate } from '@repo/shared/hooks'
import { CARD_REGEX } from '@repo/ui/lib'
import { z } from 'zod'

export const useAddCardSchema = () => {
  const { t } = useTranslate()

  const validationRules = {
    pattern: CARD_REGEX,
  }

  const addCardSchema = z.object({
    cardNumber: z
      .string({
        required_error: t('addCardPage_cardNumber_required'),
      })
      .regex(validationRules.pattern, t('addCardPage_cardNumber_invalid')),
    addSheba: z.boolean().optional(),
  })

  return {
    addCardSchema,
    validationRules,
  }
}
